export function motiveRedirectURI(linkState: string) {
  return `${process.env.REACT_APP_REDIRECT_URL}/motive?state=${linkState}`;
}
